import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Typography, Button } from '@mui/material';
import { useHistory } from 'react-router-dom';

import { URLPaths } from 'models/enums';

/**
 * Access denied page shown to users when they don't have permission to access a route.
 */
const AccessDenied = () => {
    const history = useHistory();

    const handleRedirect = () => {
        history.push(URLPaths.HOME_PAGE);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '60vh',
                padding: 4,
                textAlign: 'center',
            }}
            role="alert"
            aria-labelledby="access-denied-title"
            aria-describedby="access-denied-message"
        >
            <ErrorOutlineIcon sx={{ fontSize: '4rem', color: 'error.main', marginBottom: 2 }} aria-hidden="true" />
            <Typography id="access-denied-title" variant="h4" sx={{ marginBottom: 2, fontWeight: 600 }} component="h1">
                Access Restricted
            </Typography>
            <Typography
                id="access-denied-message"
                variant="body1"
                sx={{ marginBottom: 4, color: 'text.secondary', maxWidth: '500px' }}
            >
                You don't have permission to view this page.
            </Typography>
            <Button
                variant="contained"
                color="primary"
                onClick={handleRedirect}
                sx={{ marginTop: 2 }}
                size="large"
                aria-label="Navigate to home page"
            >
                Go to Home
            </Button>
        </Box>
    );
};

export default AccessDenied;
